import React, {Fragment} from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {
  BootstrapMaxSmallMediaQuery,
  BootstrapMinMediumMediaQuery,
} from 'app/general/mediaqueries';
import {useAccountSettingsState} from 'app/settings/api';
import {getUserStatusBadges} from 'app/user/users-badges';

import type {AlertStatusType} from 'app/user/users-statuses';
import type {UserSerializedType} from 'sweet-types';

interface Props {
  user: UserSerializedType;
  filter?: (status: AlertStatusType) => boolean;
}

export const UserStatusesBadges = ({
  user,
  filter = () => true,
}: Props): JSX.Element | null => {
  const {is_saml} = useAccountSettingsState().data!;

  const statuses = getUserStatusBadges(user, is_saml).filter(filter);

  if (statuses.length === 0) {
    return null;
  }

  return (
    <Fragment>
      {statuses.map(({icon, color, badgeDescription, alertDescription}) => (
        <LazyTooltip tooltip={alertDescription} key={icon + color}>
          <span className={`mr-1 badge badge-${color}`} key={icon + color}>
            <BootstrapMinMediumMediaQuery>
              <i className={`${icon}`} /> {badgeDescription}
            </BootstrapMinMediumMediaQuery>
            <BootstrapMaxSmallMediaQuery>
              <i className={`${icon}`} />
            </BootstrapMaxSmallMediaQuery>
          </span>
        </LazyTooltip>
      ))}
    </Fragment>
  );
};
